// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

/**
 * @description Props Interface
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Props
 */
interface Props {
    handleDrawer: any;
    navigation: any;
    user: any;
}

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Component AppBarTop
 */
export default connect((state) => state)(class AppBarTop extends React.Component<Props, {}> {

    /**
     * Creates an instance of AppBarTop.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     */
    constructor(props: any) {
        super(props);
    }

    /**
     * @description Render the AppBar Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    render() {
        return (
            <AppBar position="static" className="appbar">
                <Toolbar>
                    {this.props.user.connected &&
                        <div>
                            <IconButton color="inherit" aria-label="Menu"
                                onClick={MainStore.toggleNavigation(this.props.navigation.navigation)}>
                                <MenuIcon />
                            </IconButton>
                        </div>
                    }
                    <Typography variant="title" color="inherit" className="appbar-title">Rouges-Terres</Typography>
                    {this.props.user.connected && <Button color="inherit" onClick={MainStore.logoutUser()}>Se déconnecter</Button>}
                </Toolbar>
            </AppBar>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/AppBarTop.tsx